import { render, staticRenderFns } from "./CartonItem.vue?vue&type=template&id=b6a02a90&scoped=true"
import script from "./CartonItem.vue?vue&type=script&lang=js"
export * from "./CartonItem.vue?vue&type=script&lang=js"
import style0 from "./CartonItem.vue?vue&type=style&index=0&id=b6a02a90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a02a90",
  null
  
)

export default component.exports